export const SELF_SERVE_STEP_PATHNAMES = ['/reserve/1', '/reserve/2', '/reserve/3'];

export const RESERVABLE_TYPES = {
  hotDesk: 'HotDesk',
  dedicatedDesk: 'DedicatedDesk',
  sharedOfficeDesk: 'SharedOfficeDesk',
  office: 'Office'
};

export const RESERVABLE_TYPE_TO_MESSAGE = {
  [RESERVABLE_TYPES.hotDesk]: 'hotDesk',
  [RESERVABLE_TYPES.dedicatedDesk]: 'dedicatedDesk',
  [RESERVABLE_TYPES.sharedOfficeDesk]: 'dedicatedDesk',
  [RESERVABLE_TYPES.office]: 'privateOffice'
};

export const MARKET_FILTER_DATE_VALUES = {
  thisMonth: 'this_month',
  nextMonth: 'next_month',
  other: 'other'
};

export const MAX_DAYS_AWAY_TO_ALLOW_MOVE_IN = 42;

export const AMENITIES = {
  mailAndPackaging: 'mailAndPackaging',
  privateOfficeConferenceRoomCredits: 'privateOfficeConferenceRoomCredits',
  deskConferenceRoomCredits: 'deskConferenceRoomCredits',
  printingCredits: 'printingCredits',
  furnished: 'furnished'
};

export const FLOORPLAN_ASSET_BASE_URL = 'https://www-floorplan-assets.imgix.net';

export const ALL_ACCESS_PRODUCT_UUID = 'ca04dfa5-b8f4-4c80-b36e-f9547a23f654';

export const ON_DEMAND_COUNTRY_ALLOWLIST = ['US'];
